import React from "react";
import "./styles.scss";
import "./mobile.scss";
import { FormHeader, Tag } from "..";
import { getLanguage } from "../../utils/environment";
import moment from "moment";
import { GetIconByName } from "../../config/icon";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import useTags from "../../config/tags";

const lan = getLanguage();

const Index = ({
  data,
  onChange,
  onClick,
  isBorder,
  item,
  onChangeTag,
  tagView,
}) => {
  const history = useHistory();

  let inputElementLoading = null;
  let inputElementExtraSmall = null;
  let inputElementSmall = null;
  let inputElementMedium = null;
  let inputElementLarge = null;
  let inputElementExtraLarge = null;
  const { getTagName } = useTags();
  inputElementLoading = (
    <>
      <div className="news-card shimmer">
        <div className="shimmer-header">
          <div className="shimmer-img"></div>
          <div>
            <div className="shimmer-title"></div>
            <div className="shimmer-date"></div>
          </div>
        </div>
        <div className="shimmer-content"></div>
        <div className="shimmer-more"></div>
      </div>
    </>
  );

  inputElementExtraSmall = (
    <>
      <div className={`d-flex flex-row justify-content-between news-card-ex`}>
        {/* <img
          src={item?.images?.[0]?.url}
          alt="news-img"
          className={"ncmw__img"}
        /> */}

        <div style={{ marginLeft: "5px" }}>
          <FormHeader
            onClick={onClick}
            data={{
              lan: lan,
              formHeader: data.isUpdate
                ? "(Update) " + item?.title?.[lan]
                : item?.title?.[lan],
              size: "xs x title",
            }}
          />
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "8px" }}
          >
            <div className={"ncmw__date mt-1"}>
              {moment(item?.created_at).format("MMMM DD YYYY")}
            </div>
            <div className="d-flex mt-1">
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: item?.views,
                  type: "views_tag_sm",
                }}
              />
            </div>
          </div>
        </div>
        {/* <img
          src={item?.images?.[0]?.url}
          alt="news-img"
          className={"ncmw__img"}
        /> */}
      </div>
      {/*<div className={"ncmw__tags d-flex flex-row flex-wrap mt-1"}>*/}
      {/*  {item?.tags?.length > 0 &&*/}
      {/*    item?.tags.map((tags, index) => (*/}
      {/*      <Tag*/}
      {/*        key={index}*/}
      {/*        data={{*/}
      {/*          tagName: getTagName(tags)?.name,*/}
      {/*          type: "gray xx",*/}
      {/*        }}*/}
      {/*        onClick={() => {*/}
      {/*          history.push(`/tag/${getTagName(tags)?.name}/${tags}`);*/}
      {/*          onChangeTag({ tag_name: getTagName(tags)?.name, tag_id: tags });*/}
      {/*        }}*/}
      {/*      />*/}
      {/*    ))}*/}
      {/*</div>*/}
    </>
  );

  inputElementSmall = (
    <>
      <div className={`ncmw_small-wrapper `}>
        <div className={"ncmw__header"}>
          {/* <div className={"ncmw__img_block sm"}>
            <img
              src={item?.images?.[0]?.url}
              alt="news-img"
              className={"ncmw__img"}
            />
          </div> */}
          {item?.youtube_url && (
            <div className="ncmw_video_small">
              <div className="vIcon">{GetIconByName("video")} </div>
            </div>
          )}
          <div>
            <FormHeader
              onClick={onClick}
              data={{
                lan: lan,
                formHeader: data.isUpdate
                  ? "(Update) " + item?.title?.[lan]
                  : item?.title?.[lan],
                size: "md-lg title",
              }}
            />
            <div className="d-flex flex-row align-items-center">
              <div className={"ncmw__date"}>
                {moment(item?.created_at).format("MMM DD YYYY")}
              </div>
              <div className="d-flex ml-1 mt-1">
                <Tag
                  data={{
                    isIcon: true,
                    tagIcon: "eye",
                    tagName: item?.views,
                    type: "views_tag_sm",
                  }}
                />
              </div>
            </div>
          </div>
          {/* <div className={"ncmw__img_block sm"}>
            <img
              src={item?.images?.[0]?.url}
              alt="news-img"
              className={"ncmw__img"}
            />
          </div> */}
        </div>

        {/*<div className={"ncmw__tags d-flex flex-row flex-wrap"}>*/}
        {/*  {item?.tags?.length > 0 &&*/}
        {/*    item?.tags.map((tags, index) => (*/}
        {/*      <Tag*/}
        {/*        key={index}*/}
        {/*        data={{*/}
        {/*          tagName: getTagName(tags)?.name,*/}
        {/*          type: "gray xx",*/}
        {/*        }}*/}
        {/*        onClick={() => {*/}
        {/*          history.push(`/tag/${getTagName(tags)?.name}/${tags}`);*/}
        {/*          onChangeTag({*/}
        {/*            tag_name: getTagName(tags)?.name,*/}
        {/*            tag_id: tags,*/}
        {/*          });*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    ))}*/}
        {/*</div>*/}
        <div className={"ncmw__content"}>
          {/* {item?.content?.[lan] ||
            " හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ මුදල් සම්බන්ධයෙන් අග්‍රමාත්‍ය හරිනි අමරසූරිය විශේෂ අනාවරණයක් සිදුකළාය."}
            */}
          {item?.content ? (
            <div
              className={`ancwb__c-title ` + lan}
              dangerouslySetInnerHTML={{
                __html:
                  item?.content?.[lan].split(/\s+/).slice(0, 10).join(" ") +
                  "...",
              }}
            ></div>
          ) : (
            <>
              {(() => {
                const content = item?.content?.[lan];

                const words = content?.split(/\s+/); // Split by spaces to get words
                const truncatedContent =
                  words?.length > 25
                    ? words?.slice(0, 25).join(" ") + "..."
                    : content;

                return truncatedContent;
              })()}
            </>
          )}
        </div>
        <div className={"ncmw__more"} onClick={onClick}>
          {lan === "si" ? "වැඩි විස්තර" : "more"}
        </div>
      </div>
    </>
  );
  inputElementMedium = (
    <>
      <div className={`d-flex flex-column justify-content-between`}>
        <div>
          {/* <img
            src={item?.images?.[0]?.url}
            alt="news-img"
            className={"ncmw__img"}
          /> */}
          {item?.youtube_url && (
            <div className="ncmw_video">
              <div className="vIcon">{GetIconByName("video")} </div>
              <div className="vTitle">VIDEO</div>
            </div>
          )}
          <div className={"ncmw__header"}>
            <FormHeader
              onClick={onClick}
              data={{
                lan: lan,
                formHeader: data.isUpdate
                  ? "(Update) " + item?.title?.[lan]
                  : item?.title?.[lan],
                size: "md-lg title",
              }}
            />
          </div>
          <div
            className="d-flex flex-row align-items-center"
            style={{ gap: "8px" }}
          >
            <div className={"ncmw__date"}>
              {moment(item?.created_at).format("MMMM Do YYYY")}
            </div>
            <div className="d-flex">
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: item?.views,
                  type: "views_tag_sm",
                }}
              />
            </div>
          </div>

          {/*<div className={"ncmw__tags d-flex flex-row flex-wrap"}>*/}
          {/*  {item?.tags?.length > 0 &&*/}
          {/*    item?.tags.map((tags, index) => (*/}
          {/*      <Tag*/}
          {/*        key={index}*/}
          {/*        data={{*/}
          {/*          tagName: getTagName(tags)?.name,*/}
          {/*          type: "gray xx",*/}
          {/*        }}*/}
          {/*        onClick={() => {*/}
          {/*          history.push(`/tag/${getTagName(tags)?.name}/${tags}`);*/}
          {/*          onChangeTag({*/}
          {/*            tag_name: getTagName(tags)?.name,*/}
          {/*            tag_id: tags,*/}
          {/*          });*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    ))}*/}
          {/*</div>*/}
          <div className={"ncmw__content"}>
            {/* {item?.content?.[lan] ||
            " හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ මුදල් සම්බන්ධයෙන් අග්‍රමාත්‍ය හරිනි අමරසූරිය විශේෂ අනාවරණයක් සිදුකළාය."} */}
            {item?.content ? (
              <div
                className={`ancwb__c-title ` + lan}
                dangerouslySetInnerHTML={{
                  __html:
                    item?.content?.[lan].split(/\s+/).slice(0, 15).join(" ") +
                    "...",
                }}
              ></div>
            ) : (
              <>
                {(() => {
                  const content = item?.content?.[lan];

                  const words = content?.split(/\s+/); // Split by spaces to get words
                  const truncatedContent =
                    words?.length > 25
                      ? words?.slice(0, 25).join(" ") + "..."
                      : content;

                  return truncatedContent;
                })()}
              </>
            )}
          </div>
        </div>
        <div className={"ncmw__more"} onClick={onClick}>
          {lan === "si" ? "වැඩි විස්තර" : "more"}
        </div>
      </div>
    </>
  );
  inputElementLarge = (
    <>
      <div className={`ncmw__body `}>
        <div className={"ncmw__body_img-content"}>
          {/* <img
            src={item?.images?.[0]?.url}
            alt="news-img"
            className={"ncmw__img"}
          /> */}
        </div>
        {item?.youtube_url && (
          <div className="ncmw_video">
            <div className="vIcon"> {GetIconByName("video")}</div>
            <div className="vTitle">VIDEO</div>
          </div>
        )}
        <div className={"ncmw__header"}>
          <FormHeader
            onClick={onClick}
            data={{
              lan: lan,
              formHeader: data.isUpdate
                ? "(Update) " + item?.title?.[lan]
                : item?.title?.[lan],
              size: "md-lg title",
            }}
          />
          <div
            className="d-flex flex-row align-items-center  "
            style={{ gap: "8px" }}
          >
            <div className={"ncmw__date"}>
              {moment(item?.created_at).format("MMMM Do YYYY")}
            </div>
            <div className="d-flex mt-1 ">
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: item?.views,
                  type: "views_tag_sm",
                }}
              />
            </div>
          </div>
          {/*<div className={"ncmw__tags d-flex flex-row flex-wrap"}>*/}
          {/*  {item?.tags?.length > 0 &&*/}
          {/*    item?.tags.map((tags, index) => (*/}
          {/*      <Tag*/}
          {/*        key={index}*/}
          {/*        data={{*/}
          {/*          tagName: getTagName(tags)?.name,*/}
          {/*          type: "gray xx",*/}
          {/*        }}*/}
          {/*        onClick={() => {*/}
          {/*          history.push(`/tag/${getTagName(tags)?.name}/${tags}`);*/}
          {/*          onChangeTag({*/}
          {/*            tag_name: getTagName(tags)?.name,*/}
          {/*            tag_id: tags,*/}
          {/*          });*/}
          {/*        }}*/}
          {/*      />*/}
          {/*    ))}*/}
          {/*</div>*/}
          <div className={"ncmw__content"}>
            {/* {item?.content?.[lan] ||
              " හිටපු ජනපතිවරුන්ගේ විදෙස් සංචාර සඳහා වැය වූ මුදල් සම්බන්ධයෙන් අග්‍රමාත්‍ය හරිනි අමරසූරිය විශේෂ අනාවරණයක් සිදුකළාය."} */}
            {item?.content ? (
              <div
                className={`ancwb__c-title ` + lan}
                dangerouslySetInnerHTML={{
                  __html:
                    item?.content?.[lan].split(/\s+/).slice(0, 35).join(" ") +
                    "...",
                }}
              ></div>
            ) : (
              <>
                {(() => {
                  const content = item?.content?.[lan];

                  const words = content?.split(/\s+/); // Split by spaces to get words
                  const truncatedContent =
                    words?.length > 25
                      ? words?.slice(0, 35).join(" ") + "..."
                      : content;

                  return truncatedContent;
                })()}
              </>
            )}
          </div>
          <div className={"ncmw__more"} onClick={onClick}>
            {lan === "si" ? "වැඩි විස්තර" : "more"}
          </div>
        </div>
      </div>
    </>
  );
  inputElementExtraLarge = (
    <>
      {/* <div className={`d-flex flex-row justify-content-between`}> */}
      {/* <img
        src={item?.images?.[0]?.url}
        alt="news-img"
        className={"ncmw__img"}
      /> */}
      {item?.youtube_url && (
        <div className="ncmw_video">
          <div className="vIcon"> {GetIconByName("video")}</div>
          <div className="vTitle">VIDEO</div>
        </div>
      )}
      <div className={"ncmw__header"}>
        <FormHeader
          onClick={onClick}
          data={{
            lan: lan,
            formHeader: data.isUpdate
              ? "(Update) " + item?.title?.[lan]
              : item?.title?.[lan],
            size: "sm-x title",
          }}
        />
        <div
          className="d-flex flex-row align-items-center"
          style={{ gap: "8px" }}
        >
          <div className={"ncmw__date"}>
            {moment(item?.created_at).format("MMMM Do YYYY")}
          </div>
          <div className="views_tag_sm ">
            <Tag
              data={{
                isIcon: true,
                tagIcon: "eye",
                tagName: item?.views,
                type: "views_tag_sm",
              }}
            />
          </div>
          {item?.tags?.length > 0 && (
            <div className={"nwsng__tags d-flex flex-row flex-wrap"}>
              {item?.tags?.length > 0 &&
                item?.tags.map((tags, index) => (
                  <div
                    className="nwsng__date click"
                    onClick={() => {
                      history.push(`/tag/${getTagName(tags)?.name}/${tags}`);
                      // props.onChangeTag({
                      //   tag_name: getTagName(tags)?.name,
                      //   tag_id: tags,
                      // });
                    }}
                  >
                    #{getTagName(tags)?.name}
                  </div>
                ))}
            </div>
          )}
        </div>
        {/*<div className={"ncmw__tags d-flex flex-row flex-wrap"}>*/}
        {/*  {item?.tags?.length > 0 &&*/}
        {/*    item?.tags.map((tags, index) => (*/}
        {/*      <Tag*/}
        {/*        key={index}*/}
        {/*        data={{*/}
        {/*          tagName: getTagName(tags)?.name,*/}
        {/*          type: "gray xx",*/}
        {/*        }}*/}
        {/*        onClick={() => {*/}
        {/*          history.push(`/tag/${getTagName(tags)?.name}/${tags}`);*/}
        {/*          onChangeTag({*/}
        {/*            tag_name: getTagName(tags)?.name,*/}
        {/*            tag_id: tags,*/}
        {/*          });*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    ))}*/}
        {/*</div>*/}
        <div className={"ncmw__content"}>
          {item?.content ? (
            <div
              className={`ancwb__c-title ` + lan}
              dangerouslySetInnerHTML={{
                __html:
                  item?.content?.[lan].split(/\s+/).slice(0, 35).join(" ") +
                  "...",
              }}
            ></div>
          ) : (
            <>
              {(() => {
                const content = item?.content?.[lan];

                const words = content?.split(/\s+/); // Split by spaces to get words
                const truncatedContent =
                  words?.length > 25
                    ? words?.slice(0, 35).join(" ") + "..."
                    : content;

                return truncatedContent;
              })()}
            </>
          )}
        </div>
        <div className={"ncmw__more"} onClick={onClick}>
          {lan === "si" ? "වැඩි විස්තර" : "more"}
        </div>
      </div>
      {/* </div> */}
    </>
  );

  return (
    <>
      <div
        className={`news-card-main-wrapper ${data.type}  ${
          data.isBorder ? "border-bottom" : ""
        } ${data.mainLayerStyles} `}
      >
        {data.type === "loading" && <>{inputElementLoading}</>}
        {data.type === "extrasmall" && <>{inputElementExtraSmall}</>}
        {data.type === "small" && <>{inputElementSmall}</>}
        {data.type === "medium" && <>{inputElementMedium}</>}
        {data.type === "large" && <>{inputElementLarge}</>}
        {data.type === "extralarge" && <>{inputElementExtraLarge}</>}
        {/* {data.isBorder && (
          <>
            <div className={"border-bottom"}></div>
          </>
        )} */}
      </div>
    </>
  );
};

export default Index;
